<!--Header-->
<div class="modal-header text-center" style="color: white;background-color: #544d84">    
    <h4 class="modal-title w-100">{{x_titulo}}</h4>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="onClosemodal()">
      <span aria-hidden="true" class="white-text">&times;</span>
    </button>
</div>
  
<!--Body-->
<div class="modal-body">    
    <mdb-card>
        <mdb-card-body>        
            <div class="form-row" style="align-items: baseline;">
                <div class="col-2">Código:</div>
                <div class="col-2">                
                  <input mdbInput type="text" maxlength="6"  class="form-control" [(ngModel)]="txtCodigoSigaSec" placeholder="0000-0">
                </div>
                <div class="form-group col-md-5">
                    <div class="md-form mt-0 mb-0">
                        <input type="text" id="txtdescripcion_bus" maxlength="100" [(ngModel)]="txtdescripcion_bus" class="form-control" mdbInput>
                        <label for="txtdescripcion_bus">Descripción</label>
                    </div>
                </div>                
                <div class="form-group col-md-3">
                        <button mdbBtn type="button" id="btnBuscar" (click)="onBuscar()" size="sm" color="deep-purple" mdbWavesEffect>
                        <mdb-icon fas icon="search" class="mr-1"></mdb-icon>Buscar</button>                    
                </div>                
            </div>
        </mdb-card-body>
      </mdb-card>
      <br/>
      <div style="text-align: left;padding-bottom: 5px;font-weight: 500;font-size: 13px;">Total : {{listConceptos.response.list.length}}</div>
      <mdb-card>        
        <div class="table-responsive">
        <table mdbTable hover="true">
            <thead>
              <tr>
                <th *ngFor="let head of headElements" scope="col">{{head}}</th>
              </tr>
            </thead>
            <tbody>
              <tr mdbTableCol *ngFor="let listConceptos of listConceptos.response.list | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize">
                <td>{{listConceptos.cincodigo}}-{{listConceptos.idstpcodigo}}</td>
                <td>{{listConceptos.sindescrip}}</td>
                <td>{{listConceptos.idmoncodigo}}</td>
                <td>{{listConceptos.cinimporte}}</td>
                <td><button type="button" (click)="onSeleccionar(listConceptos)" color="deep-purple" outline="true" class="btn-sm" mdbWavesEffect mdbBtn>Seleccionar</button></td>
              </tr>
            </tbody>
          </table>
          </div>
            <div class="text-center">
              
              <ngb-pagination [maxSize]=3 [(page)]="page" class="d-flex justify-content-center"
                [pageSize]="pageSize" [boundaryLinks]="true" [collectionSize]="listConceptos.response.list.length">
              </ngb-pagination>
              
            </div>
                
      </mdb-card>
    <br>
  
</div>  
  <!--Footer-->
<div class="modal-footer justify-content-center">

</div>